import * as yup from 'yup';

export const useWorkOrderValidationSchema = () => {
  const schema = yup.object({
    messageNotification: yup.object({
      tenantChat: yup.boolean(),
    }),
    workOrderSurveys: yup.object({
      allowFeedback: yup.boolean(),
      autoSurveyTriggerStatus: yup
        .string()
        .nullable()
        .when('allowFeedback', {
          is: true,
          then: (schema: yup.StringSchema<string | null>) => schema.required(),
          otherwise: (schema: yup.StringSchema<string | null>) => schema.nullable(),
        }),
    }),
  });

  return schema;
};
